module.exports = __webpack_public_path__ + "static/media/desafio_covid19.cf2d5899.png";